import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { XCircle } from "@phosphor-icons/react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="flex min-h-screen items-center justify-center bg-[#0B0D17] px-5">
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.4 }}
        data-testid="payment-cancel-page"
        className="w-full max-w-md rounded-3xl border border-white/10 bg-[#12141F] p-10 text-center"
      >
        <XCircle size={48} weight="fill" className="mx-auto text-slate-500" />
        <h1 className="mt-6 font-display text-2xl font-bold text-white">Checkout canceled</h1>
        <p className="mt-2 text-sm text-slate-400">
          No charge was made. You can upgrade to premium anytime.
        </p>
        <button
          data-testid="cancel-back-btn"
          onClick={() => navigate("/")}
          className="mt-8 w-full rounded-full bg-blue-600 py-3 text-sm font-semibold text-white transition-colors hover:bg-blue-500"
        >
          Back to Directory
        </button>
      </motion.div>
    </div>
  );
}
